

























import { Component, Vue } from "vue-property-decorator";

@Component
export default class Login extends Vue {
  username: string;
  password: string;

  constructor() {
    super();
    this.username = "";
    this.password = "";
  }

  login() {
    // console.log("username: " + this.username + ", password: " + this.password)
    this.password = "";
    this.$message.error("Login failed");
  }

  logout() {}
}
